import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {TasksApiService} from '../../../../../Services/Api/Tasks/General/tasks-api.service';
import {TaskDto} from '../../../../../Models/Tasks/General/task.interface';
import {TaskActionsEnum} from '../../../../../Shared/Enum/task-actions.enum';
import {TaskFilters} from '../../../../../Models/Tasks/General/task-filters.model';

@Component({
  selector: 'app-inventory-scheduled-pendents-widget',
  templateUrl: './inventory-scheduled-pendents-widget.component.html',
  styleUrls: ['./inventory-scheduled-pendents-widget.component.scss'],
  standalone: false
})
export class InventoryScheduledPendentsWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 1;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected tasksService: TasksApiService,
  ) {
    super(injector, tasksService);
  }


  /**
   * Obtener los inventarios programad0s pendientes
   *
   */
  override setData(data: TaskDto[]) {
    this.data = data.filter((item) => !item.cerrado && item.action && item.id_subtipo === TaskActionsEnum.inventory)?.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: TaskFilters = new TaskFilters();
    filters.id_local = this.widgetsManager.filters?.local.id || 0;

    return this.tasksService.getTasks(filters, false);
  }

}
